<template>
  <div class="user-center__notice-container user-center__common-child-container">
    <SubPageHeader>
      <template #title>
        <router-link
          tag="div"
          :to="nav.url"
          active-class="active"
          class="title__front-item"
          v-for="(nav, index) in breadcrumbs"
          :key="index"
          >{{ nav.name }}</router-link
        >
      </template>
    </SubPageHeader>
    <div class="notice__main-body" v-if="lists">
      <div
        class="main-body__item"
        v-for="list in lists"
        :key="list.id"
        :class="{
          unread: Number(list.status) === 0,
          cursor: Number(list.type) !== 4,
        }"
        @click="jump"
        :data-type="list.type"
        :data-targetid="list.target_id"
        :data-id="list.id"
        :data-url="list.url"
      >
        <div class="item__wrapper">
          <div class="item__icon">
            <i class="icon icon-notice"></i>
          </div>
          <div class="item__info">
            <p class="info__created">{{ list.ctime | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}</p>
            <p class="info__text">[{{ list.title }}]{{ list.content }}</p>
          </div>
        </div>
      </div>
    </div>
    <empty hint="暂无未读消息" v-else></empty>
    <pagination
      class="component-pagination"
      v-if="paginationConfig"
      :config="paginationConfig"
    ></pagination>
  </div>
</template>

<script>
import { scrollToUp } from "@/assets/utils/common";
import { list, hasRead } from "@/api/notice";
import Empty from "@/pages/common/empty.vue";
import Pagination from "@/components/pagination.vue";
import { mapState } from "vuex";
import SubPageHeader from "../_pageHeader.vue";

export default {
  components: {
    SubPageHeader,
    Pagination,
    Empty,
  },
  data() {
    return {
      breadcrumbs: [
        {
          name: "我的消息",
          url: "/my/notices",
        },
      ],
      pageSize: 16,
      paginationConfig: null,
      lists: null,
      requesting: false,
    };
  },
  computed: {
    ...mapState("user", {
      userInfo: (state) => state.info,
    }),
    page() {
      return this.$route.query.page || 1;
    },
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    // 项目报备已读边未读
    readFollowup() {
      console.log("111");
    },
    async init() {
      // 获取数据
      this.$store.commit("openLoading");
      console.log(this.page);
      const res = await list({
        page: this.page,
        page_size: this.pageSize,
      });
      const { data } = res;
      this.lists = data.list.length === 0 ? null : data.list;
      this.paginationConfig = data.total.num === 0 ? null : data.total;
      scrollToUp();
      this.$store.commit("closeLoading");
    },
    read(e) {
      const target = e.currentTarget;
      const { id } = target.dataset;
      if (!this.requesting) {
        this.requesting = true;
        hasRead(id).then(() => {
          this.lists.map((item) => {
            const temp = item;
            if (Number(temp.id) === Number(id)) {
              temp.status = 1;
            }
            return temp;
          });
          this.$message({
            type: "success",
            message: "操作成功",
          });
        });
        this.requesting = false;
      } else {
        this.$message({
          type: "warning",
          message: "操作中，请稍后",
        });
      }
    },
    jump(e) {
      const that = this;
      const data = e.currentTarget.dataset;
      let path;
      switch (Number(data.type)) {
        case 1:
          path = `/case/${data.targetid}`;
          break;
        case 2:
          path = `/product/${data.targetid}`;
          break;
        case 3:
          path = `/requirement/${data.targetid}`;
          break;
        case 5:
          // path = `/my/dynamics/${data.targetid}`;
          window.open(data.url);
          break;
        case 6:
          path = `/merchant/${data.targetid}/cases`;
          break;
        default:
          break;
      }
      if (data.targetid > 0 && path) {
        if (
          that.userInfo.isMerchant &&
          that.userInfo.isAuthMerchant &&
          Number(that.userInfo.identity) === 3
        ) {
          that
            .$confirm("升级成厂家店解锁更多功能", "提示信息", {
              confirmButtonText: "升级",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              that.$router.push({
                path: "/my/auth",
              });
            })
            .catch(() => {
              console.log("取消");
            });
          return;
        }
        that.$router.push({
          path,
        });
      }
    },
  },
};
</script>

<style></style>
